var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "725px",
    height: "536px",
    viewBox: "0 0 725 536",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets/YellowLines") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets/YellowLines",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 4.70016207,
    y: 403.175439,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 0,
    y: 438.438596,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 28.2009724,
    y: 343.22807,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 23.5008104,
    y: 378.491228,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 50.5267423,
    y: 373.789474,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 45.8265802,
    y: 409.052632,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 74.0275527,
    y: 373.789474,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 69.3273906,
    y: 409.052632,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 97.528363,
    y: 343.22807,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 92.828201,
    y: 378.491228,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 119.854133,
    y: 305.614035,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 115.153971,
    y: 340.877193,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 143.354943,
    y: 269.175439,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 138.654781,
    y: 304.438596,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 165.680713,
    y: 238.614035,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 160.980551,
    y: 273.877193,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 189.181524,
    y: 269.175439,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 184.481361,
    y: 304.438596,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 212.682334,
    y: 238.614035,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 207.982172,
    y: 273.877193,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 235.008104,
    y: 199.824561,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 230.307942,
    y: 235.087719,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 258.508914,
    y: 134,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 253.808752,
    y: 169.263158,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 465.316045,
    y: 134,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 460.615883,
    y: 169.263158,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 488.816856,
    y: 134,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 484.116694,
    y: 169.263158,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 534.643436,
    y: 79.9298246,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 529.943274,
    y: 115.192982,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 556.969206,
    y: 79.9298246,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 552.269044,
    y: 115.192982,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 580.470016,
    y: 0,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 575.769854,
    y: 35.2631579,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 603.970827,
    y: 0,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 599.270665,
    y: 35.2631579,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 719.124797,
    y: 0,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 714.424635,
    y: 35.2631579,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 626.296596,
    y: 48.1929825,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 621.596434,
    y: 83.4561404,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 673.298217,
    y: 48.1929825,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 668.598055,
    y: 83.4561404,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 695.623987,
    y: 48.1929825,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 690.923825,
    y: 83.4561404,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 649.797407,
    y: 79.9298246,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 645.097245,
    y: 115.192982,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 280.834684,
    y: 134,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 276.134522,
    y: 169.263158,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 511.142626,
    y: 102.263158,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 506.442464,
    y: 137.526316,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 304.335494,
    y: 199.824561,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 299.635332,
    y: 235.087719,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 327.836305,
    y: 199.824561,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 323.136143,
    y: 235.087719,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 350.162075,
    y: 238.614035,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 345.461912,
    y: 273.877193,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 373.662885,
    y: 269.175439,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 368.962723,
    y: 304.438596,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 395.988655,
    y: 238.614035,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 391.288493,
    y: 273.877193,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 419.489465,
    y: 199.824561,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E3E56",
    fillRule: "nonzero",
    x: 414.789303,
    y: 235.087719,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 442.990276,
    y: 199.824561,
    width: 1.17504052,
    height: 132.824561,
    rx: 0.587520259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2BF30",
    fillRule: "nonzero",
    x: 438.290113,
    y: 235.087719,
    width: 10.5753647,
    height: 62.2982456,
    rx: 2.19251497
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLines);
export default __webpack_public_path__ + "static/media/YellowLines.73864e0c62d6963ea09696c78c9b3e9b.svg";
export { ForwardRef as ReactComponent };